import { green, grey, red } from "@mui/material/colors";

const styles = {
  automationsButton: {
    borderRadius: 9999,
    textTransform: "none",
    color: "#364153",
    borderColor: "#e5e7eb",
    fontSize: 12,
    fontWeight: 500,
    height: 30,
    px: 1.5,
    mr: 1,
    "&:hover": {
      borderColor: "#d1d5db",
      backgroundColor: "#f9fafb",
    },
  },
  border: {
    borderBottom: `1px solid ${grey[300]}`,
    px: 2,
    py: 1,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
  },
  header: {
    backgroundColor: { xs: "secondary.light", md: "none" },
    fontSize: 16,
    py: 1,
    px: 2,
    display: "flex",
    alignItems: "center",
  },
  close: {
    width: 20,
    height: 20,
    fontSize: 14,
  },
  automationRow: {
    width: "100%",
    textAlign: "left",
    cursor: "pointer",
    "&:hover": {
      backgroundColor: grey[50],
    },
  },
  bulkScheduleActive: {
    color: green[400],
    mr: 1,
  },
  bulkScheduleInactive: {
    color: red[400],
    mr: 1,
  },
};

export default styles;
